import React from "react";

import { GroupCardsButton } from "../styles";
import { useCardsStore } from "../../../../stores/use-cards-store";
import { useTranslation } from "react-i18next";
import { CARDS_PROP } from "../../drawers/settings/features/cards/defaults";
import { DEFAULT_TAB } from "../../../../features/cards-v2/components/tabs/defaults";

const GroupCards = () => {
  const {
    data,
    updateCardsConfig,
    updateCardsTabs,
    updateCardsData,
    setCardsTab,
  } = useCardsStore((state) => ({
    data: state.data,
    updateCardsConfig: state.updateCardsConfig,
    updateCardsTabs: state.updateCardsTabs,
    updateCardsData: state.updateCardsData,
    setCardsTab: state.setCardsTab,
  }));

  const { t } = useTranslation();

  if (!Object.keys(data).length) return <></>;

  const { config, tabs = [] } = data[0];

  const hasTabs = !!tabs.length;

  return (
    <GroupCardsButton
      onClick={() => {
        updateCardsConfig({ key: CARDS_PROP.HAS_TABS, value: !config.hasTabs });

        if (!hasTabs) {
          updateCardsTabs([DEFAULT_TAB]);
          updateCardsData({ key: CARDS_PROP.TAB_ID, value: DEFAULT_TAB.id });
          setCardsTab(DEFAULT_TAB);
        }
      }}
    >
      {t(config.hasTabs ? "ungroup-cards" : "group-cards-in-tabs")}
    </GroupCardsButton>
  );
};

export default GroupCards;
